import { render, staticRenderFns } from "./StudentSubjectsTable.vue?vue&type=template&id=15eb8e02"
import script from "./StudentSubjectsTable.vue?vue&type=script&lang=js"
export * from "./StudentSubjectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports